import { useState, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'AuthProvider';
import { auth } from '../utils/auth';
import { axios } from '../common';
import { Box, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import useConstructor from '../hooks/useConstructor';

const ProtectedRoute = ({ children }) => {
  const [pending, setPending] = useState(false);
  const { user, setUser } = useAuth();
  const location = useLocation();

  useConstructor(() => {
    (async function () {
      if (auth.isAuthenticated()) {
        try {
          const { status, data } = await axios.get('/accounts');

          if (status === 200) {
            setUser(data);
            setPending(true);
          }
        } catch {}
        setPending(true);
      } else {
        setPending(true);
      }
    })();
  });

  // useEffect(() => {
  //   (async function () {
  //     if (auth.isAuthenticated()) {
  //       console.log('auth');
  //       try {
  //         const { status, data } = await axios.get('/accounts');

  //         if (status === 200) {
  //           setUser(data);
  //           setPending(true);
  //         }
  //       } catch {}
  //       setPending(true);
  //     } else {
  //       setPending(true);
  //     }
  //   })();
  // }, [setUser]);

  const renderLogin = useMemo(() => {
    return !user ? <Navigate to="/login" state={{ from: location.pathname }} replace /> : children;
  }, [children, location.pathname, user]);

  return !pending ? (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress />
    </Box>
  ) : (
    renderLogin
  );
};

ProtectedRoute.propTypes = {
  children: PropTypes.node
};

export default ProtectedRoute;
